const upgrade = {
  pricingTitle: '选择套餐',
  pricingSubtitle: '选择最适合你招聘节奏的方案，开启高效 AI 人才寻访与评估。',
  upgradeNow: '立即升级',
  pricingTabs: {
    pro: '个人版',
    business: '企业版',
  },
  billingCycles: {
    monthly: '月付',
    semiannual: '半年',
    annual: '年付',
  },
  double11Title: '双11限定优惠',
  double11Deadline: '2026/11/11 23:59 截止 · 北京时间',
  recommendedBadge: '推荐',
  highFrequencyBadge: '高频招聘首选',
  saveBadge: '双11特惠',
  pointsPackageTab: '积分包',
  pointsPackageEmpty: '暂无无可购买的积分包',
  pointsPackageDesc: '补充联系积分，适合会员按需加购。',
  pointsPackageFallbackName: '积分包',
  pointsPackageCredits: '{count} 联系积分',
  pointsPackageCreditUnit: '积分',
  pointsPackageBenefit: '购买后积分将由后台确认后发放',
  pointsPackageOneTime: '一次性购买',
  pointsPackageVipRequired: '仅新手会员及以上可购买积分包',
  pointsPackageVipRequiredShort: '新手会员以上可购',
  buyPointsPackage: '购买积分包',
  vipOnlyBadge: '新手会员及以上专享',
  pricingPlans: {
    starter: {
      name: '新手会员',
      description: '适合轻量招聘和初尝 AI 匹配评估',
      unit: 'USD / 30 天',
      dailyPrice: '$0.03 USD / 日',
      actionText: '开通新手会员',
      features: [
        '1,500 AI 积分 / 30 天',
        '包含 1 个席位',
        '岗位对话、人才寻访与匹配评估',
        '邮件模板与批量发送',
        '联系积分 0',
      ],
      promotion: '新手尝鲜专享 · 每人限购一次',
    },
    basic: {
      name: '新手会员',
      description: '适合轻量招聘和初尝 AI 匹配评估',
      unit: 'USD / 30 天',
      dailyPrice: '$0.03 USD / 日',
      actionText: '开通新手会员',
      features: [
        '1,500 AI 积分 / 30 天',
        '包含 1 个席位',
        '岗位对话、人才寻访与匹配评估',
        '邮件模板与批量发送',
        '联系积分 0',
      ],
    },
    professional: {
      name: '专业版',
      description: '适合独立招聘顾问与持续寻访团队',
      badge: '双11推荐',
      unit: 'USD / 月',
      dailyPrice: '$1.30 USD / 日',
      actionText: '升级到专业版',
      features: [
        '14,000 AI 积分 / 月',
        '包含 1 个席位',
        '岗位对话、人才寻访与匹配评估',
        '邮件模板与批量发送',
        '联系积分 20 积分 / 月',
      ],
      promotion: '限时约6.6折 · 立省 $20',
    },
    professionalAnnual: {
      name: '专业版',
      description: '适合独立招聘顾问与持续寻访团队',
      badge: '双11推荐',
      unit: 'USD / 年',
      dailyPrice: '月均 $48.17 USD · 较原年价省 $102',
      actionText: '升级到专业版',
      features: [
        '168,000 AI 积分 / 年（月均 14,000）',
        '包含 1 个席位',
        '岗位对话、人才寻访与匹配评估',
        '邮件模板与批量发送',
        '联系积分 240 积分 / 年（月均 20）',
      ],
      promotion: '年付85折 · 立省 $102',
    },
    professionalPro: {
      name: '专业版Pro',
      description: '适合高频招聘和进阶 AI 匹配分析',
      badge: '高频招聘首选',
      unit: 'USD / 月',
      dailyPrice: '$2.63 USD / 日',
      actionText: '升级到专业版Pro',
      features: [
        '26,500 AI 积分 / 月',
        '包含 1 个席位',
        '岗位对话、人才寻访与匹配评估',
        '邮件模板与批量发送',
        '联系积分 45 积分 / 月',
      ],
    },
    professionalSemiannual: {
      name: '专业版半年期',
      description: '适合持续招聘，半年一次性开通',
      badge: '半年套餐',
      unit: 'USD / 半年',
      dailyPrice: '$1.90 USD / 日',
      actionText: '立即支付',
      features: [
        '180 天会员',
        '84,000 AI 积分',
        '包含 1 个席位',
        '岗位对话、人才寻访与匹配评估',
        '邮件模板与批量发送',
        '120 个联系积分',
      ],
    },
    professionalProSemiannual: {
      name: '专业版Pro半年度',
      description: '适合高频招聘，半年一次性开通',
      badge: '半年套餐',
      unit: 'USD / 半年',
      dailyPrice: '$2.63 USD / 日',
      actionText: '立即支付',
      features: [
        '180 天会员',
        '159,000 AI 积分',
        '包含 1 个席位',
        '岗位对话、人才寻访与匹配评估',
        '邮件模板与批量发送',
        '270 个联系积分',
      ],
    },
    professionalProAnnual: {
      name: '专业版Pro年度',
      description: '适合大规模招聘运营，年度一次性开通',
      badge: '年度套餐',
      unit: 'USD / 年',
      dailyPrice: '$2.59 USD / 日',
      actionText: '立即支付',
      features: [
        '365 天会员',
        '318,000 AI 积分',
        '包含 1 个席位',
        '岗位对话、人才寻访与匹配评估',
        '邮件模板与批量发送',
        '540 个联系积分',
      ],
    },
    enterpriseStandardMonthly: {
      name: '企业版',
      description: '月度参考价，企业套餐按年购买',
      unit: 'USD / 月',
      dailyPrice: '$6.63 USD / 日',
      actionText: '按年购买',
      features: [
        '30,000 AI 积分 / 月',
        '包含 2 个席位（1+1）',
        '岗位对话、人才寻访与匹配评估',
        '邮件模板与批量发送',
        '批量 AI InMail',
        '人才库与岗位人才 Excel 导出',
        '联系积分 45 积分 / 月',
      ],
    },
    enterpriseGrowthMonthly: {
      name: '企业增长版',
      description: '月度参考价，企业套餐按年购买',
      badge: '推荐',
      unit: 'USD / 月',
      dailyPrice: '$9.97 USD / 日',
      actionText: '按年购买',
      features: [
        '45,000 AI 积分 / 月',
        '包含 4 个席位（1+3）',
        '岗位对话、人才寻访与匹配评估',
        '邮件模板与批量发送',
        '批量 AI InMail',
        '人才库与岗位人才 Excel 导出',
        '联系积分 120 积分 / 月',
      ],
    },
    enterpriseStandardSemiannual: {
      name: '企业版半年期',
      description: '适合成长期招聘团队，半年一次性开通',
      unit: 'USD / 半年',
      dailyPrice: '$6.63 USD / 日',
      actionText: '立即支付',
      features: [
        '180,000 AI 积分 / 半年',
        '包含 2 个席位（1+1）',
        '岗位对话、人才寻访与匹配评估',
        '邮件模板与批量发送',
        '批量 AI InMail',
        '人才库与岗位人才 Excel 导出',
        '联系积分 270 积分 / 半年',
      ],
    },
    enterpriseGrowthSemiannual: {
      name: '企业增长版半年期',
      description: '适合高增长企业，半年一次性开通',
      badge: '推荐',
      unit: 'USD / 半年',
      dailyPrice: '$9.97 USD / 日',
      actionText: '立即支付',
      features: [
        '270,000 AI 积分 / 半年',
        '包含 4 个席位（1+3）',
        '岗位对话、人才寻访与匹配评估',
        '邮件模板与批量发送',
        '批量 AI InMail',
        '人才库与岗位人才 Excel 导出',
        '联系积分 720 积分 / 半年',
      ],
    },
    enterpriseStandardAnnual: {
      name: '企业版',
      description: '专为成长期招聘团队打造，全流程协同招聘',
      unit: 'USD / 年',
      dailyPrice: '月均 $179.17 USD',
      actionText: '立即支付',
      features: [
        '360,000 AI 积分 / 年',
        '包含 2 个席位（1+1）',
        '岗位对话、人才寻访与匹配评估',
        '邮件模板与批量发送',
        '批量 AI InMail',
        '人才库与岗位人才 Excel 导出',
        '联系积分 540 积分 / 年',
      ],
      promotion: '年付约9折 · 立省 $238',
    },
    enterpriseGrowthAnnual: {
      name: '企业增长版',
      description: '适合高增长企业与规模型招聘团队',
      badge: '推荐',
      unit: 'USD / 年',
      dailyPrice: '月均 $269.17 USD',
      actionText: '立即支付',
      features: [
        '540,000 AI 积分 / 年',
        '包含 4 个席位（1+3）',
        '岗位对话、人才寻访与匹配评估',
        '邮件模板与批量发送',
        '批量 AI InMail',
        '人才库与岗位人才 Excel 导出',
        '联系积分 1,440 积分 / 年',
      ],
      promotion: '年付约9折 · 立省 $358',
    },
    contactPoints10: {
      name: '10 个联系积分',
      description: '联系积分包，仅会员可购买',
      unit: 'USD',
      unitPrice: '$0.70 USD / 个',
      actionText: '购买积分包',
    },
    contactPoints30: {
      name: '30 个联系积分',
      description: '联系积分包，仅会员可购买',
      unit: 'USD',
      unitPrice: '$0.60 USD / 个',
      actionText: '购买积分包',
    },
    contactPoints100: {
      name: '100 个联系积分',
      description: '联系积分包，仅会员可购买',
      unit: 'USD',
      unitPrice: '$0.57 USD / 个',
      actionText: '购买积分包',
    },
    contactPoints300: {
      name: '300 个联系积分',
      description: '联系积分包，仅会员可购买',
      unit: 'USD',
      unitPrice: '$0.57 USD / 个',
      actionText: '购买积分包',
    },
    contactPoints1000: {
      name: '1000 个联系积分',
      description: '联系积分包，仅会员可购买',
      unit: 'USD',
      unitPrice: '$0.57 USD / 个',
      actionText: '购买积分包',
    },
  },
  trialDaysBadge: '{days} 天试用',
  autoRenewBadge: '自动续费',
  startTrial: '开始试用',
  currentPlanAction: '当前套餐',
  lowerPlanAction: '已高于此套餐',
  upgradeToPlan: '升级到{planName}',
  activeMembershipExists: '当前已是 {planName} 或更高等级会员',
  paymentReturn: {
    checking: {
      title: '支付结果确认中',
      desc: '已返回 EasyHireAI，正在刷新订单、订阅和当前权益。',
    },
    success: {
      title: '支付成功，权益已刷新',
      desc: '后端已确认支付结果，当前页面展示的是最新权益数据。',
    },
    pending: {
      title: '支付结果等待确认',
      desc: 'Waffo 回调可能稍有延迟，当前不会判定失败。可稍后刷新结果或查看个人中心。',
    },
    failed: {
      title: '支付未完成或已失败',
      desc: '后端返回了未完成状态，请重新发起支付或联系支持确认订单。',
    },
    refresh: '刷新结果',
    planLabel: '支付项目',
    orderLabel: '订单号',
    assets: {
      contact: '联系积分',
      aiMatch: 'AI 积分',
      jobs: '岗位数',
      membership: '会员状态',
    },
    membershipStatus: {
      active: '订阅生效中',
      trialing: '试用中',
      canceling: '已取消自动续费',
      canceled: '会员已结束',
      past_due: '续费失败',
      expired: '已过期',
      none: '未开通',
    },
  },
  subscriptionAiMatchBenefit: 'AI 积分 {count}',
  subscriptionJobCountBenefit: '最多管理 {count} 个岗位',
  subscriptionMembershipBenefit: '会员权益生效中',
  subscriptionFallbackName: '会员订阅',
  subscriptionPlanDesc: '订阅后按周期自动续费',
  productBenefits: {
    membershipDays: '{count} 天会员',
    aiMatch: '{count} AI 积分',
    enterpriseAiCredits: '{count} AI 积分',
    enterpriseAiCreditsMonthly: '{count} AI 积分 / 月',
    jobs: '最多管理 {count} 个岗位',
    unlimitedJobs: '不限岗位数量',
    contactPoints: '{count} 个联系积分',
    contactPointsMonthly: '{count} 个联系积分 / 月',
    noContactPoints: '联系积分 0',
    agentConversations: '{count} Agent 对话',
    seats: '包含 {count} 个席位',
  },
  cancelAutoRenew: '取消自动续费',
  cancelAutoRenewTitle: '取消自动续费',
  cancelAutoRenewDesc: '取消后当前会员权益可使用至 {date}，到期后不会再自动扣费。',
  cancelAutoRenewConfirm: '确认取消',
  cancelAutoRenewSuccess: '已取消自动续费',
  cancelAutoRenewFailed: '取消自动续费失败，请稍后重试',
  subscriptionCheckoutDesc: '将打开 Waffo 收银台完成订阅。订阅开通后会按所选周期自动续费。',
  membershipRequired: {
    toast: '该积分包需要有效会员，请先开通会员。',
  },
  membershipRequiredTitle: '开通会员后可使用',
  goToMembership: '去开通会员',
  chinaIdentityFilterPrompt: '是否华人、是否有中企经历为会员专属筛选，开通会员后即可使用。',
  aiMatchMembershipPrompt: 'AI 积分不足，开通或升级会员后可继续查看简历评分。',
  agentOpenJobMembershipPrompt: 'AIAgent智能化招聘 续费原积分可保留',
  sales: {
    moreFeatures: '贵组织需要更多功能？',
    businessCta: '联系销售',
    businessCardTitle: '定制企业方案',
    businessCardDesc: '适合需要更多席位、专属额度或专属支持的组织',
    businessCardPrice: '定制报价',
    businessCardFeatures: [
      '灵活配置 AI 积分与联系积分',
      '按需增加团队席位与权限管理',
      '专属方案制定与 1 对 1 企业支持',
      '定制 API 对接与私有化数据保障',
    ],
    dialogTitle: '联系销售',
    qrAlt: '联系销售二维码',
    customPlanHint: '扫码联系销售顾问，获取企业专属定制方案与报价。',
    invoiceNote:
      "开票流程：wechat 支付的用户请将开票信息 + 账号 + 金额发送至 chris{'@'}easyhireai.com，周五统一回复！",
  },
  ctaTitle: '会员已过期',
  ctaDesc: '开通更多会员权益',
  ctaAction: '立即升级',
  dialogTitle: '选择最适合你招聘节奏的方案。',
  suppressToday: '今日不再弹出',
  currentMembership: '当前会员：',
  vipMember: '试用会员',
  nonMember: '会员已过期',
  trialMember: '试用会员',
  trialDuration: '试用日期 {days} 天',
  trialExpired: '已过期',
  singlePurchaseLimit: '请联系销售开通会员，每个用户限购一个会员套餐',
  popularBadge: '热门推荐',
  planLabel: '方案亮点',
  contactSales: '联系销售',
  salesQrHint: '扫码联系销售',
  choosePlan: '选择计划',
  contactSalesCustom: '预约演示',
  paymentTitle: '扫码支付并备注代码',
  paymentDesc: '下单后会持续接收支付状态更新，支付成功后会员状态会自动刷新。',
  paymentWarning:
    '扫码付款时，请在付款备注填写购买码：\n【{code}】\n（用于确认您的订单，否则需要人工处理）\n付款成功后，预计 10 分钟内充值成功。',
  paymentPlaceholder: '正在生成支付二维码...',
  paymentCodeLabel: '购买码',
  paymentOrderLabel: '订单号',
  paymentExpireLabel: '过期时间',
  paymentCopyCode: '复制购买码',
  paymentRefresh: '刷新状态',
  paymentCancel: '取消订单',
  deadlineNoticeEyebrow: '正式套餐已更新',
  deadlineNoticeTitle: 'EasyHireAI 正式定价体系已上线',
  deadlineNoticeSubtitle: '选择最适合你招聘节奏的方案。',
  deadlineNoticeDesc: '新套餐现已上线，价格与权益一目了然，欢迎选择适合你的方案立即开通。',
  contactSalesStageTitle: '联系销售定制方案',
  contactSalesStageHint: '扫码联系销售，获取专属报价与定制服务方案。',
  contactSalesClose: '返回套餐',
  productsLoadingTitle: '正在加载套餐信息',
  productsLoadingDesc: '请稍候，商品信息准备完成后会自动继续。',
  createOrderFailed: '创建订单失败，请稍后重试',
  purchaseLimitExceeded: '该商品已达到每位用户的购买上限，商品列表已刷新',
  paymentSuccessMessage: '充值成功，会员状态已更新。',
  paymentSuccessTitle: '支付成功',
  contactSalesStageDesc: '{planName} 需要销售协助配置，我们已经帮您准备好联系二维码。',
  planProductMissing: '当前套餐暂未配置支付商品',
  planProductPendingAction: '待配置支付',
  semiannualMinimumAction: '按年购买',
  planDisplayOnlyAction: '仅展示',
  planDisplayOnlyReason: '该价格仅供展示，请切换到年度购买',
  confirmPurchaseMessage: '确认购买 {planName} 吗？确认后将生成支付订单。',
  confirmPurchaseTitle: '确认购买',
  orderFailedTitle: '下单失败',
  codeCopied: '备注码已复制',
  paymentChannelLabel: '支付方式',
  channelWecom: '微信支付',
  channelWaffo: 'Waffo 支付',
  payByWecom: '微信支付',
  payByWaffo: '立即支付',
  paymentMethodDialogTitle: '选择支付方式',
  paymentMethodDialogDesc: '请选择支付方式。微信支付完成后，后台确认到账会自动刷新会员权益。',
  wechatPaymentTitle: '微信支付',
  wechatPaymentWaitingHint: '请在微信支付备注中填写 4 位支付码，管理员确认后自动到账。',
  wechatPaymentCodeLabel: '付款备注码',
  wechatPaymentExpiredHint: '订单未完成或已失效，请重新发起支付。',
  wechatPaymentQrMissing: '未获取到微信支付二维码，请稍后重试。',
  waffoPaymentTitle: '前往 Waffo 完成支付',
  waffoPaymentDesc: '点击下方按钮前往 Waffo 收银台完成付款，支付成功后会员状态会自动刷新。',
  waffoRedirectHint: '正在前往 Waffo 收银台，请在跳转后的页面完成支付。',
  waffoOpenCheckout: '前往 Waffo 收银台',
  waffoPendingHint: '支付结果将在你返回后自动确认，请勿关闭此窗口。',
  paymentInProgressTitle: '支付进行中',
  paymentInProgressMessage: '当前有订单正在支付流程中，离开可能丢失支付状态，确定要离开吗？',
  paymentInProgressConfirm: '确认离开',
  enterpriseFeature: {
    title: '企业版专属功能',
    description: '此功能为企业版专属功能，请联系销售顾问开通。',
    featureDescription: '「{feature}」为企业版专属功能，请联系销售顾问开通。',
    contactSales: '联系销售',
    scanQrHint: '微信扫码联系专属销售顾问',
    emailContactHint: '通过邮件联系销售团队：',
    copyEmail: '复制邮箱',
    copiedEmail: '已复制邮箱地址',
    sendEmail: '发送邮件',
    viewPlans: '查看企业方案',
  },
  pricingBenefitsLabel: '会员权益',
  pricingContactCreditsLabel: '联系积分',
  pricingFitForLabel: '适合人群',
}

export default upgrade
